import Api from '@/services/api'

export default {
  namespaced: true,
  state: {
    loading: false,
    list: null,
    has_more: false,
    error_message: '',
    post_modal_shown: false,
    page: 1,
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value
    },
    setList(state, data) {
      if (!state.list) {
        state.list = data.feeds
      } else {
        state.list = state.list.concat(data.feeds)
      }
      state.has_more = !!data.next_page_url
    },

    clearList(state) {
      state.list = null
      state.page = 1
    },

    setPage(state, page) {
      state.page = page
    },

    setLikedFeeds(state, data) {
      state.list.map((val) => {
        let fid = data.feed ? data.feed.fid : data
        if (val.fid === fid) {
          val.is_liked = true
          !data.feed ? val.total_likes++ : ``
        }
      })
    },

    unsetLikedFeeds(state, data) {
      state.list.map((val) => {
        let fid = data.feed ? data.feed.fid : data
        if (val.fid === fid) {
          val.is_liked = false
          !data.feed ? val.total_likes-- : ``
        }
      })
    },

    handleError(state, error) {
      if (error.response && error.response.data) {
        state.error_message = error.response.data.message
      }
    },

    togglePostModal(state, value) {
      state.post_modal_shown = value
    },
  },

  actions: {
    async getList({ commit }, params) {
      await Api.get(`posts/${params.influencer_uid}/all`, { params })
        .then(({ data }) => {
          commit('setList', data.data)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },

    async getHomeFeeds({ commit }, params) {
      commit('setLoading', true)
      await Api.get(`feeds`, {
        params: {
          ...params,
          exclude_ar: 1,
        },
      })
        .then(({ data }) => {
          commit('setList', data.data)
          commit('setPage', params.page)
        })
        .catch((error) => {
          commit('handleError', error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },

    showLessFeeds({ commit, state: { list, page } }) {
      if (!list.length) {
        return
      }

      let hideCount = list.length % 8
      if (hideCount === 0) {
        hideCount = 8
      }

      const newList = [...list].slice(0, hideCount * -1)
      const data = {
        feeds: newList,
        next_page_url: true,
      }

      commit('clearList')
      commit('setList', data)
      commit('setPage', page - 1)
    },

    async likeFeed({ commit }, params) {
      await Api.put(`feed/${params}`)
        .then(({ data }) => {
          commit('setLikedFeeds', data.data)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },

    async unlikeFeed({ commit }, params) {
      await Api.delete(`feed/${params}`)
        .then(({ data }) => {
          commit('unsetLikedFeeds', data.data)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },

    setunsetLikeFeed({ commit, dispatch }, params) {
      if (params.is_liked) {
        commit('unsetLikedFeeds', params.fid)
        dispatch('unlikeFeed', params.fid)
      } else {
        commit('setLikedFeeds', params.fid)
        dispatch('likeFeed', params.fid)
      }
    },
  },
}
